import styled from "styled-components";

export const StyledAddSongs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .songs-list {
    display: flex;
    flex-direction: column;
    gap: 1px;

    .song-list-item {
      display: flex;
      align-items: center;
    }
  }

  .song-input {
    display: flex;
  }
  
`;